import { render } from "./DropDownItem.vue?vue&type=template&id=6abbe7e1&scoped=true&ts=true"
import script from "./DropDownItem.vue?vue&type=script&lang=ts"
export * from "./DropDownItem.vue?vue&type=script&lang=ts"

import "./DropDownItem.vue?vue&type=style&index=0&id=6abbe7e1&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6abbe7e1"]])

export default __exports__